import { Export } from '../types/exports';
import { QualityEventsGet } from '../types';
import api, { medtechApi } from './index';

export type ExportsFilterParams = QualityEventsGet & { format?: string; columns?: string[] };

const exportsApi = {
  async createExport(company: number, filterParams?: ExportsFilterParams): Promise<Export | undefined> {
    const res = await api.post(`/company/${company}/exports`, filterParams);
    return res.data.data as Export;
  },
  async createExportSearch(company: number, filterParams?: ExportsFilterParams): Promise<{ task_id: string | null }> {
    const res = await medtechApi.post(`/quality-events/${company}/export-search`, filterParams);
    return res.data as { task_id: string | null };
  },
  async getSearchExport(company: number, taskId: string): Promise<Export | undefined> {
    const res = await medtechApi.get(`/v2/${company}/tasks/${taskId}`);
    return res.data as Export;
  },
  async getExport(company: number, exportId: string): Promise<Export | undefined> {
    const res = await api.get(`/company/${company}/exports/${exportId}`);
    return res.data.data as Export;
  },
};

export default exportsApi;
